export const colors = [
  { id: 'darkBlue', value: '#0071BC' },
  { id: 'lightBlue', value: '#34BDE7' },
  { id: 'seagreen', value: '#00A99D' },
  { id: 'darkGreen', value: '#009245' },
  { id: 'lightGreen', value: '#79C942' },
  { id: 'yellow', value: '#EBD900' },
  { id: 'orange', value: '#F7931E' },
  { id: 'pink', value: '#FF7BAC' },
  { id: 'red', value: '#F23738' },
  { id: 'purple', value: '#7B47AF' },
  { id: 'gray', value: '#BDCCD4' },
  { id: 'lightBrown', value: '#D9BB8A' },
  { id: 'darkBrown', value: '#A67C52' },
  { id: 'anthracite', value: '#333333' },
];
